function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  fill: "currentColor",
  x: 5,
  y: 8,
  width: 8,
  height: 2,
  rx: 1,
  fillRule: "evenodd"
});

var SvgMicro = function SvgMicro(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 18,
      height: 18
    }, props), _ref)
  );
};

export default SvgMicro;